/* eslint-disable */
import { useMemo } from "react";
import { useDictionary, useOLAPTransformer, OLAPTransformerResult, OLAPTransformerOptions, useParameter } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";
import { Dictionary } from "@sa/rep-mdm";
import { OLAPResult } from "@sa/rep-olap";
import { SLIDE_NUMBER } from "../constants";

const ROW_AXIS = "calendar.default";
const COLUMN_AXIS = "countries.default";

export function useTableData(olapResult: OLAPResult | null): OLAPTransformerResult | null {
  const [, rowsDict] = useDictionary(dictionaryService, "slides-calendar");
  const [businessUnit] = useParameter<number>('@business-units');
  const [commodity] = useParameter<number>('@commodities');
  const [itemsColumns, columnsDict] = useDictionary(dictionaryService, "slides-countries");
  const [itemsColumnsDisplay] = useDictionary(dictionaryService, "slides-countries-display", undefined, {
    'slide': SLIDE_NUMBER,
    'business_unit': businessUnit,
    'olap_commodity': commodity,
  });

  const options = useMemo<OLAPTransformerOptions | null>(() => {
    if ([olapResult, columnsDict, rowsDict, itemsColumns, itemsColumnsDisplay].some(x => !Boolean(x))) {
      return null;
    }

    return {
      data: olapResult?.data,
      attrsNameProxy: new Map([
        [`${COLUMN_AXIS}.name`, (id: unknown, lcid: number) => {
          const itemDisplay = itemsColumnsDisplay?.find(x => Number(x.getValue('olap_country')) === Number(id));
          const item = itemsColumns?.find(x => Number(x.id) === Number(id));
          return (itemDisplay || item)?.getValue('name') || { [lcid]: '' };
        }]
      ]),
      attrsDictionaries: new Map([
        [COLUMN_AXIS, columnsDict],
        [ROW_AXIS, rowsDict],
      ]) as ReadonlyMap<string, Dictionary>
    } as OLAPTransformerOptions
  }, [olapResult, columnsDict, rowsDict, itemsColumns, itemsColumnsDisplay]);

  const query = useMemo(() => {
    return {
      lcid: 9,
      columns: [`${COLUMN_AXIS}.name`, `${COLUMN_AXIS}.id`],
      rows: [`${ROW_AXIS}.name`, `${ROW_AXIS}.id`],
      cellData: {
        inCell: ["Measures.value"],
        attributes: [`${COLUMN_AXIS}.name`, `${ROW_AXIS}.name`, `${COLUMN_AXIS}.id`, `${ROW_AXIS}.id`],
      },
    }
  }, []);
  const data = useOLAPTransformer(options, query);
  return data;
}
